import { Avatar } from '@chakra-ui/avatar'
import { Box, Flex, Text } from '@chakra-ui/layout'
import { ElementoTooltip } from '../../../../../components/ElementoTooltip'
import { iNomeId, iRespostaQuestao } from '../../../../../interfaces'

interface iProps {
  questao: iRespostaQuestao
  respondente?: iNomeId
}

export const QuestaoComentario: React.FC<iProps> = ({ questao, respondente }) => {
  return (
    <Flex flexDir={'column'} gap='.5rem'>
      {questao.alternativaResposta.map((res, i2) => {
        return (
          <Box key={i2} my={'.25rem'} bgColor={'var(--Gray6)'} py={'.5rem'} px={'1.25rem'}>
            <Flex alignItems={'center'} gap={'.5rem'} mb={'.5rem'}>
              <ElementoTooltip label={respondente?.nome}>
                <Avatar src={respondente?.avatar} size={'xs'}/>
              </ElementoTooltip>
              <Text fontSize={'13px'} fontWeight={'600'}>{respondente?.complemento}</Text>
            </Flex>
            <Text fontSize={'14px'}>{res.resposta?.split('\n').map(text => {
              return <p>{text}</p>
            })}</Text>
          </Box>
        )
      })}
    </Flex>
  )
}
